__turbopack_context__.v({
  "closeButton": "Dialog-module-scss-module__aWqYyW__closeButton",
  "closeIcon": "Dialog-module-scss-module__aWqYyW__closeIcon",
  "header": "Dialog-module-scss-module__aWqYyW__header",
  "scrollableContent": "Dialog-module-scss-module__aWqYyW__scrollableContent",
});
